import { TicketPaymentDetails } from './TicketPaymentDetails'

const TicketPaymentTabs = (): JSX.Element => <TicketPaymentDetails />

export default TicketPaymentTabs
